import { UseFormReturnType } from '@mantine/form';
import { EventVisibility, Transparency } from '../../utils/rule';
import { SyncRuleFormValues } from './interface';

export function getMappedText(original: string, transformation: string): string {
    return transformation.replace('%original%', original);
}

export type OnboardingTemplateKey = 'busy' | 'copy';

export interface TemplateApplySetters {
    setDestinationTitle: (s: string) => void;
    setDestinationDescription: (s: string) => void;
}

export function applyBusyTemplate(
    form: UseFormReturnType<SyncRuleFormValues>,
    setters: TemplateApplySetters,
    busyText: string,
): void {
    form.setValues({
        ...form.values,
        summary: busyText,
        description: '',
        include_conference_link: 'false',
        keep_location: 'false',
        includeAllDayEvents: '1',
        visibility: EventVisibility.PRIVATE,
        transparency: Transparency.set_to_opaque,
    });
    setters.setDestinationTitle(busyText);
    setters.setDestinationDescription('');
}

export function applyCopyTemplate(
    form: UseFormReturnType<SyncRuleFormValues>,
    setters: TemplateApplySetters,
    defaultTitle: string,
    defaultDescription: string,
): void {
    form.setValues({
        ...form.values,
        summary: '%original%',
        description: '%original%',
        include_conference_link: 'true',
        keep_location: 'true',
        includeAllDayEvents: '1',
        transparency: Transparency.keep_original,
        visibility: EventVisibility.KEEP_ORIGINAL,
    });
    setters.setDestinationTitle(defaultTitle);
    setters.setDestinationDescription(defaultDescription);
}

export function applyTransparentTemplate(
    form: UseFormReturnType<SyncRuleFormValues>,
    setters: TemplateApplySetters,
    defaultTitle: string,
    defaultDescription: string,
    companyNamePlaceholder: string,
): void {
    const summaryTemplate = `${companyNamePlaceholder} %original%`;
    form.setValues({
        ...form.values,
        summary: summaryTemplate,
        description: '%original%',
        include_conference_link: 'true',
        includeAllDayEvents: '1',
        keep_location: 'true',
        transparency: Transparency.keep_original,
        visibility: EventVisibility.PUBLIC,
    });
    setters.setDestinationTitle(getMappedText(defaultTitle, summaryTemplate));
    setters.setDestinationDescription(getMappedText(defaultDescription, '%original%'));
}

export function applyPrefixSuffix(
    form: UseFormReturnType<SyncRuleFormValues>,
    setters: TemplateApplySetters,
    prefix: string,
    suffix: string,
    defaultTitle: string,
    defaultDescription: string,
): void {
    const summary = `${prefix}%original%${suffix}`;
    form.setFieldValue('summary', summary);
    setters.setDestinationTitle(getMappedText(defaultTitle, summary));
    setters.setDestinationDescription(getMappedText(defaultDescription, form.values.description));
}
